import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "../components/Logo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-3xl border border-navy/10 bg-white p-10 text-center shadow-xl shadow-navy/10">
        <div className="flex justify-center">
          <Logo />
        </div>
        <h1 className="mt-10 font-display text-2xl font-bold text-navy">Paiement annulé</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          Aucun montant n'a été débité. Si vous avez des questions ou préférez passer par un
          devis, nous sommes joignables à tout moment.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 border-t border-navy/10 pt-6">
          <a
            data-testid="payment-cancel-phone"
            href="tel:+33784678802"
            className="flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-gold-dark"
          >
            <Phone size={15} /> 07 84 67 88 02
          </a>
          <Link data-testid="payment-cancel-home" to="/" className="text-sm font-medium text-slate-500 transition-colors hover:text-navy">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
